import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useGetInfiniteMedicalReportsByPatient} from '@/features/medical-reports/queries/useGetInfiniteMedicalReportsByPatient'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {InfoCircleIcon} from '@/components/ui/icon/Icon'
import {useTheme} from 'styled-components'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {useGetMedicalReport} from '@/features/medical-reports/queries/useGetMedicalReport'
import {closeProjectReasonsMapToLabel} from '@/features/medical-reports/utils'
import {ClosingReason} from '@/features/medical-reports/types'

export const ProjectDetailsHeaderEarlyClosingMotivation = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()
    const {remappedData: medicalReports} = useGetInfiniteMedicalReportsByPatient({
        urlParams: {patientId: project.patientId},
        params: {
            search: 'Chiusura progetto continuativo',
            projectId: project.id,
            limit: 1
        }
    })

    const {data: medicalReport} = useGetMedicalReport({
        urlParams: {medicalReportId: medicalReports[0]?.id},
        params: {responseType: 'extended'},
        options: {enabled: !!medicalReports[0]?.id}
    })

    const {palette} = useTheme()

    const earlyClosingMotivation = medicalReport?.medicalRecordReportAttributes?.find(
        attribute => attribute.name == 'closureReason'
    )?.value

    if (!medicalReport || !earlyClosingMotivation) {
        return null
    }

    return (
        <Tooltip variant="light" content={t(closeProjectReasonsMapToLabel[earlyClosingMotivation as ClosingReason])}>
            <Flexbox gap={2} align="center">
                <InfoCircleIcon size={16} color={palette.neutral[950]} />
                <Text size="textSm" weight="500" palette="neutral" shade="950" style={{textDecoration: 'underline'}}>
                    {t('projects:patient_decision')}
                </Text>
            </Flexbox>
        </Tooltip>
    )
}
